<template>
  <div>
    <Dashboard v-if="hasPermissionsTo(['manage-monitoring'])"/>
    <h3 v-else>Welcome to Acadia!</h3>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import Dashboard from "./Dashboard";

  export default {
    name: "Welcome",
    computed: {
      ...mapGetters("auth", ["hasPermissionsTo"]),
      ...mapState({auth: state => state.auth}),
    },
    components: {
      Dashboard
    }
  }
</script>